var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-container',{staticClass:"fill-height",attrs:{"id":"auth"}},[_c('v-card',{staticClass:"pa-5",attrs:{"elevation":"10","color":"#ffffff"}},[_c('Login')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }